import { B as i } from "./chunk-BaseElement-BuXbltG-.js";
import { W as n } from "./chunk-WithShopifyCart-CoFAHix4.js";
import { x as r, E as e } from "./chunk-lit-element-CNHURX5C.js";
class s extends n(i) {
  static get properties() {
    return {
      translation: { type: Object },
      prefix: { type: String },
      postfix: { type: String }
    };
  }
  constructor() {
    super(), this.translation = {
      cart_count: null
    }, this.prefix = "", this.postfix = "";
  }
  get translatedCartCount() {
    var t;
    return ((t = this.translation) == null ? void 0 : t.cart_count) || "###count### items in your cart";
  }
  render() {
    return r`
      ${this.cart.item_count > 99 ? e : r`
            <span aria-hidden="true"
              >${this.prefix + this.cart.item_count + this.postfix}</span
            >
          `}
      <span class="sr-only"
        >${this.translatedCartCount.replace(
      "###count###",
      String(this.cart.item_count)
    )}</span
      >
    `;
  }
}
window.customElements.define("cart-total", s);
export {
  s as CartTotal
};
